export default {"src":"/_next/static/media/trustpilot_full_star_black.f9e26f84.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};